document.addEventListener('DOMContentLoaded', function() {
  var tabs     = document.querySelectorAll('.product-tabs__item');
  var contents = document.querySelectorAll('.tab-content');

  tabs.forEach(function(tab) {
    tab.addEventListener('click', function() {
      tabs.forEach(function(t){ t.classList.remove('is-active'); });
      tab.classList.add('is-active');
      var name = tab.getAttribute('data-tab');
      contents.forEach(function(c){
        c.id === name
          ? c.classList.add('is-active')
          : c.classList.remove('is-active');
      });
    });
  });
});
